export const MM_MAIN_ELEMENT_ID = 'mm-application-layout-main';
export const HEADER_LEFT_ELEMENT = 'mm-header-left';
